// src/context/PopularCourseContext.js
import React, { createContext, useContext, useEffect, useState } from "react";

const PopularCourseContext = createContext();

export const usePopularCourses = () => useContext(PopularCourseContext);

export const PopularCourseProvider = ({ children }) => {
  const [popularCourses, setPopularCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const cacheBuster = `?_=${new Date().getTime()}`;
        const response = await fetch(`https://www.denisbitter.de/stage01/api/get_courses.php${cacheBuster}`);
        const data = await response.json();

        if (data.success) {
          const filtered = data.data.filter(course => course.isFavorite === true || course.isFavorite === "1");
          setPopularCourses(filtered);
        } else {
          throw new Error(data.message || "Unbekannter Fehler");
        }
      } catch (err) {
        console.error("Fehler beim Laden der beliebten Kurse:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchCourses();
  }, []);

  return (
    <PopularCourseContext.Provider value={{ popularCourses, loading, error }}>
      {children}
    </PopularCourseContext.Provider>
  );
};
